export default __webpack_public_path__ + "static/media/2008.6852ac10.png";